import { render, staticRenderFns } from "./CompFeedPlan.vue?vue&type=template&id=4701ab35"
import script from "./CompFeedPlan.vue?vue&type=script&lang=js"
export * from "./CompFeedPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports